// @ts-nocheck
import * as React from 'react';
import { truncateWithEllipses } from 'utils/utilities';
import './bodyText.scss';
interface Props extends React.PropsWithChildren<any> {
	marginLeft?: string | number; // Add marginLeft prop
}

const BodyText: React.FunctionComponent<Props> = (props) => {
	const { marginLeft } = props;
	return (
		<div className="body--text" style={{ marginLeft: marginLeft || '0px' }}>
			{props.ellipsis ? truncateWithEllipses(props.children, props.ellipsis) : props.children}{' '}
		</div>
	);
};

export default BodyText;
